module.exports = __webpack_public_path__ + "img/image-undraw-advanced-customization.3949fce6.svg";